import { CssBaseline } from '@mui/material';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import router from '@/routes';
import theme from '@/theme';
import { initSentry, SentryErrorBoundary } from '@/utils/sentry';

import './index.css';
import SuspenseWrapper from './modules/common/shared/Suspense';
import SnackbarProvider from './modules/common/snackbar';
import { queryClient } from './queryClient';
import './utils/i18n/index';
import './utils/smartlook';

initSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SentryErrorBoundary>
      <CssBaseline>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <SnackbarProvider>
              <QueryClientProvider client={queryClient}>
                <SuspenseWrapper>
                  <RouterProvider router={router} />
                </SuspenseWrapper>
              </QueryClientProvider>
            </SnackbarProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      </CssBaseline>
    </SentryErrorBoundary>
  </React.StrictMode>
);
